import { render, staticRenderFns } from "./ValidationsView.vue?vue&type=template&id=3745023c&scoped=true"
import script from "./ValidationsView.vue?vue&type=script&lang=js"
export * from "./ValidationsView.vue?vue&type=script&lang=js"
import style0 from "./ValidationsView.vue?vue&type=style&index=0&id=3745023c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3745023c",
  null
  
)

export default component.exports